<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import Bus from "utils/bus.js";
export default {
  name: "app",
  components: {},
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      // isforecast: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less" rel="stylesheet/less">
#app {
  width: 100%;
  height: 100%;
  min-width:1600px;
  position: relative;
  overflow: auto;
  font-family: "opposans";
}
@font-face {
  //数字字体 所有数字都用这个字体
  font-family: "Alternate";

  src: url("./assets/iconfont/Alternate.ttf");
}
@font-face {
  //数字字体 所有数字都用这个字体
  font-family: "opposans";

  src: url("./assets/iconfont/OPPOSans-M.ttf");
}
@font-face {
  //粗体苹方 所有标题用这个字体
  font-family: "PingFangblod";
  src: url("./assets/iconfont/pingfangbold.ttf");
}
@font-face {
  //正常苹方 默认字体
  font-family: "PingFang";
  src: url("./assets/iconfont/pingfang.ttf");
}
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}
</style>
